const PRIMARY_COLOR = '#FFB829';
const SECONDARY_COLOR = '#FF1D89';
const BLACK = '#0E1017';
const GRADIENT_FROM = '#0E1017';
const GRADIENT_TO = '#212224';
const BUTTON_GRADIENT_FROM = '#FFB829';
const BUTTON_GRADIENT_TO = '#914706';

const lightTheme = {
    primaryColor: PRIMARY_COLOR,
    secondaryColor: SECONDARY_COLOR,
    backgroundColor: BLACK,
    appbarColor: BLACK,
    navbarColor: `linear-gradient(0deg, ${GRADIENT_FROM}, ${GRADIENT_TO})`,
    buttonColor: `linear-gradient(90deg, ${BUTTON_GRADIENT_FROM}, ${BUTTON_GRADIENT_TO})`,
    buttonHoverColor: `linear-gradient(90deg, ${BUTTON_GRADIENT_FROM}, ${BUTTON_GRADIENT_TO})`,
}

export default lightTheme;